import { useContext } from "react";
import { MdArrowForward } from "react-icons/md";
import {
  TbAd2,
  TbGift,
  TbPalette,
  TbPrinter,
  TbShirt,
  TbSignRight,
  TbVectorBezier,
} from "react-icons/tb";
import { AppContext } from "../App";
import cnc from "../assets/cnc.png";

export default function HomeServiceSection() {
  const appContext = useContext(AppContext);

  const services = [
    {
      title: "Custom Printing",
      text: "High-quality prints for every need.",
      icon: <TbPrinter />,
    },
    {
      title: "Brand Identity",
      text: "Logos, colors, and designs that define you.",
      icon: <TbPalette />,
    },
    {
      title: "Large Format Printing",
      text: "Billboards, banners, and beyond.",
      icon: <TbAd2 />,
    },
    {
      title: "Laser and CNC printing",
      text: "high-quality printing, produce fast, sharp, and professional prints on different materials.",
      icon: (
        <img
          src={cnc}
          alt=""
          aria-hidden="true"
          className="home-service-icon-img"
        />
      ),
    },
    /* */ 
    {
      title: "Corporate Gifts",
      text: "Impress with unique and premium gifts.",
      icon: <TbGift />,
    },
    {
      title: "Signage Solutions",
      text: "Indoor, outdoor and directional signage.",
      icon: <TbSignRight />,
    },
    {
      title: "Merchandise Printing",
      text: "Apparel and accessories that represent.",
      icon: <TbShirt />,
    },
    {
      title: "Design Support",
      text: "Creative design that brings ideas to life.",
      icon: <TbVectorBezier />,
    },
  ];

  function exploreProducts() {
    appContext.navTo({
      item: "products",
    });
  }

  return (
    <section className="MainBodySection home-service-section">
      <div className="container">
        <div className="home-service-layout">
          <div className="home-service-intro" data-aos="fade-up">
            <p className="home-banner-kicker">What We Do</p>

            <h2 className="home-service-title font-bold">
              Creative Printing.
              <br />
              Powerful Branding.
            </h2>

            <span className="home-service-mark" aria-hidden="true" />

            <p className="home-service-copy">
              End-to-end printing and branding solutions crafted to elevate your
              brand presence.
            </p>

            <button
              type="button"
              className="home-service-btn"
              onClick={exploreProducts}
            >
              Explore Our Products
              <MdArrowForward size={24} />
            </button>
          </div>

          <div className="home-service-grid" data-aos="fade-left">
            {services.map((service) => (
              <article className="home-service-item" key={service.title}>
                <div className="home-service-icon">{service.icon}</div>
                <h3 className="home-service-card-title font-bold">
                  {service.title}
                </h3>
                <p>{service.text}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
